import { commanServicer } from "./common.services";

async function login(loginData: any) {

    return await commanServicer.fetchRequest(JSON.stringify(loginData), false, 'login', 'POST');
}

async function  logOut() {
    return await commanServicer.fetchRequest('', true, 'UserMaster/logout', 'POST');
}

async function resetPassword(userPassword : any) {
    return await commanServicer.fetchRequest(JSON.stringify(userPassword), true, 'resetpassword','POST');
}
 

export const userServicer = {

    login,
    logOut,   
    resetPassword
}